module.exports = __webpack_public_path__ + "static/030.thumb-073d88572494c3d33e462d420dd8e420.jpg";